import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const propTypes = {
  className: PropTypes.string,
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  addon: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  onClick: PropTypes.func.isRequired,
  active: PropTypes.bool,
};

const DesignEditorPrimaryControlButton = ({
  className,
  icon,
  title,
  addon,
  onClick,
  active,
}) => {
  const classes = classNames({
    'design-editor-controls-primary-btn': true,
    'is-active': active,
    [className]: !!className,
  });

  return (
    <a
      href="#"
      className={classes}
      onClick={event => {
        event.preventDefault();
        onClick();
      }}
      title={title}
    >
      <div className="design-editor-controls-primary-btn-icon">{icon}</div>
      <div className="design-editor-controls-primary-btn-title">{title}</div>
      {addon && (
        <div className="design-editor-controls-primary-btn-addon">{addon}</div>
      )}
    </a>
  );
};

DesignEditorPrimaryControlButton.propTypes = propTypes;

export default DesignEditorPrimaryControlButton;
